import React from "react";
import { COLORS } from "../constants";
import { fontSerif } from "./styles";

/**
 * HotspotPanel — slide-in info card for clicked markers.
 *
 *   - If `hotspot.route` is set (= one of the 4 main landmarks), render both
 *     an "Enter" button (navigates to /landmark/:id) and a "Close" button.
 *   - If no route (= Points of Interest), the marker is info-only; render
 *     only a full-width "Close" button and a small "Point of Interest" eyebrow.
 */
export default function HotspotPanel({ hotspot, onEnter, onClose }) {
  if (!hotspot) return null;
  const isLandmark = !!hotspot.route;
  const eyebrow = isLandmark ? "Hotspot" : "Point of Interest";

  return (
    <div
      data-testid="zone-hotspot-panel"
      data-hotspot-kind={isLandmark ? "landmark" : "poi"}
      style={{
        position: "absolute",
        top: "50%",
        right: 24,
        transform: "translateY(-50%)",
        width: 320,
        background:
          "linear-gradient(180deg, rgba(11,21,48,0.92) 0%, rgba(15,31,74,0.92) 100%)",
        border: `1px solid ${COLORS.gold}`,
        borderRadius: 14,
        padding: 22,
        color: COLORS.ivory,
        fontFamily: fontSerif,
        boxShadow: `0 20px 60px rgba(0,0,0,0.5), 0 0 30px rgba(230,180,80,0.15)`,
        backdropFilter: "blur(10px)",
        zIndex: 10,
      }}
    >
      <div
        style={{
          fontSize: 10,
          letterSpacing: 4,
          color: COLORS.gold,
          textTransform: "uppercase",
          marginBottom: 8,
        }}
      >
        {eyebrow}
      </div>
      <div
        data-testid="zone-hotspot-title"
        style={{
          fontSize: 22,
          marginBottom: 10,
          color: COLORS.goldBright,
          letterSpacing: 0.5,
        }}
      >
        {hotspot.label}
      </div>
      <div
        data-testid="zone-hotspot-description"
        style={{
          fontSize: 14,
          lineHeight: 1.6,
          opacity: 0.9,
          fontStyle: "italic",
          marginBottom: 18,
        }}
      >
        {hotspot.description}
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        {isLandmark && (
          <button
            data-testid="zone-hotspot-enter"
            onClick={() => onEnter(hotspot)}
            style={{
              flex: 1,
              padding: "10px 14px",
              border: "none",
              borderRadius: 8,
              backgroundColor: COLORS.gold,
              color: COLORS.navyDeep,
              fontFamily: fontSerif,
              fontSize: 12,
              letterSpacing: 2,
              fontWeight: 700,
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Enter
          </button>
        )}
        <button
          data-testid="zone-hotspot-close"
          onClick={onClose}
          style={{
            flex: 1,
            padding: "10px 14px",
            border: `1px solid ${COLORS.navyMid}`,
            borderRadius: 8,
            background: "transparent",
            color: COLORS.ivory,
            fontFamily: fontSerif,
            fontSize: 12,
            letterSpacing: 2,
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}
